<template>
  <SAIInput
    :value="value"
    v-bind="$attrs"
    type="email"
    :large="true"
    :placeholder="placeholder"
    @input="(val) => $emit('input', val)"
  >
    <template v-slot:prepend>
      <QIcon
        class="q-mr-xs"
        color="grey-9"
        size="22px"
        name="eva-email-outline"
      />
    </template>
  </SAIInput>
</template>

<script>
import { QIcon } from 'quasar';

export default {
  name: 'SAIEmailInput',
  props: {
    value: {
      type: undefined
    },
    placeholder: {
      type: String,
      default: 'Enter Email Address'
    }
  },
  components: {
    SAIInput: () => import('../sai-input'),
    QIcon
  }
};
</script>
